export const ONE_WAY = [
  'token-hashing', 'multi-cluster-management'
];

export const HARVESTER_NAME = 'harvester';
export const SCHEDULING_CUSTOMIZATION = 'cluster-agent-scheduling-customization';
